var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[_c('div',{staticClass:"text-caption"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"text-body-2 black--text"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }